// extracted by mini-css-extract-plugin
export default {"button":"Button_button__Yn7Iz","dark":"Button_dark__Y2bo7","grey":"Button_grey__AVYfB","orange":"Button_orange__nhSB8"};